module.exports = __webpack_public_path__ + "img/bj-dt-2.780f5e17.png";